export const ARTICLE_NAME_SORT_KEY = "name";
export const ARTICLE_NAME_SORT_LABEL = "Article name";
export const SORT_ASCENDING = "asc";
export const SORT_DESCENDING = "desc";

const FLAT_ARTICLE_EXCLUDED_KEYS = ["id", "edit", "archived"];

function compareValues(a, b) {
  const isEmpty = value => value === "" || value === null || value === undefined;
  const numA = isEmpty(a) ? NaN : Number(a);
  const numB = isEmpty(b) ? NaN : Number(b);

  if (!Number.isNaN(numA) && !Number.isNaN(numB)) {
    return numA - numB;
  }

  const strA = String(isEmpty(a) ? "" : a).toLowerCase();
  const strB = String(isEmpty(b) ? "" : b).toLowerCase();

  if (strA === strB) return 0;
  return strA > strB ? 1 : -1;
}

export function sortArticles(articles, sortKey, direction, getValue) {
  const factor = direction === SORT_DESCENDING ? -1 : 1;
  return (articles || [])
    .slice()
    .sort((a, b) => compareValues(getValue(a, sortKey), getValue(b, sortKey)) * factor);
}

export function buildSortOptions(articles, getKeysForArticle) {
  const keys = new Set();
  (articles || []).forEach(article => {
    getKeysForArticle(article).forEach(key => {
      if (key && key !== ARTICLE_NAME_SORT_KEY) keys.add(key);
    });
  });

  return [
    { key: ARTICLE_NAME_SORT_KEY, label: ARTICLE_NAME_SORT_LABEL },
    ...Array.from(keys).map(key => ({ key, label: key })),
  ];
}

export function getFlatArticleKeys(article) {
  return Object.keys(article || {}).filter(
    key => !FLAT_ARTICLE_EXCLUDED_KEYS.includes(key)
  );
}

export function getFlatArticleValue(article, key) {
  return article ? article[key] : "";
}

export function getArticleDataKeys(article, dataProperty = "articleData") {
  return ((article && article[dataProperty]) || []).map(variable => variable.key);
}

export function getArticleDataValue(article, key, dataProperty = "articleData") {
  if (key === ARTICLE_NAME_SORT_KEY) return article.name;
  const variable = ((article && article[dataProperty]) || []).find(
    v => v.key === key
  );
  return variable ? variable.data : "";
}
